import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgModule
} from '@angular/core';
import { BasicDocument } from '../../../core/declarations/document.interface';
import { FileUpload } from '../../../core/declarations/file.interface';
import { mimeTypes } from '../forms/file/file.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@NgModule({})
export class DocumentImageComponentIconsModule {}

@Component({
  selector: 'fl-document-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg-icon
      *ngIf="fileType === 'doc'"
      key="file-doc"
      class="success"
      [title]="'COMMON.DOCUMENTS.WORD' | translate"
    ></svg-icon>
    <svg-icon
      *ngIf="fileType === 'pdf'"
      key="file-pdf"
      class="danger"
      [title]="'COMMON.DOCUMENTS.PDF' | translate"
    ></svg-icon>
    <ion-icon
      *ngIf="fileType === 'video'"
      name="videocam-outline"
      class="secondary"
      [attr.aria-label]="'COMMON.DOCUMENTS.VIDEO' | translate"
    ></ion-icon>
    <ion-icon
      *ngIf="fileType === 'audio'"
      name="musical-notes-outline"
      class="secondary"
      [attr.aria-label]="'COMMON.DOCUMENTS.AUDIO' | translate"
    ></ion-icon>
    <ion-icon
      *ngIf="fileType === 'image'"
      name="image-outline"
      class="secondary"
      [attr.aria-label]="'COMMON.DOCUMENTS.IMAGE' | translate"
    ></ion-icon>
    <svg-icon
      *ngIf="fileType === 'unknown'"
      key="file-unknown"
      class="warning"
      [title]="'COMMON.DOCUMENTS.OTHER' | translate"
    ></svg-icon>
  `,
  styleUrls: ['./document-image.component.scss'],
  imports: [
    SvgIconComponent,
    TranslateModule,
    NgIf,
    IonicModule,
    DocumentImageComponentIconsModule
  ]
})
export class DocumentImageComponent {
  public fileType: 'doc' | 'pdf' | 'video' | 'audio' | 'image' | 'unknown';

  @Input() set document(doc: FileUpload | BasicDocument) {
    const type = 'content_type' in doc ? doc.content_type : doc.mimeType;
    const media = type?.split('/')[0];

    if (media === 'video' || media === 'audio' || media === 'image') {
      this.fileType = media;
      return;
    }

    const extension = Object.entries(mimeTypes).find(([k]) => k === type)?.[1];

    this.fileType =
      extension === 'doc' || extension === 'pdf' ? extension : 'unknown';
  }
}
